import { type ISVGIconProps, IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { type RemotenessTypes } from 'shared/types/RemotenessTypes';

import styles from './RemotenessIcon.css';

type RemotenessIconProps = {
  iconType: RemotenessTypes;
  iconColor: string | null;
};

export const RemotenessIcon: FC<RemotenessIconProps> = props => {
  const { iconType, iconColor } = props;

  const Icon = ((): FC<ISVGIconProps> => {
    switch (iconType) {
      case 'transport':
        return IconMapCar16;
      case 'walk':
        return IconMapWalk16;
    }
  })();

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['container']} style={iconColor ? { color: iconColor } : undefined}>
      <Icon color={iconColor ? 'current_color' : undefined} data-testid={`remoteness-icon-${iconType}`} />
    </div>
  );
};
